import React from 'react';
const SiteContext = React.createContext({ isPremiumSite: false });
export const SiteContextProvider = ({ site, children, }) => React.createElement(SiteContext.Provider, { value: site }, children);
export function withSiteContext(Component) {
    return (props) => {
        const { isPremiumSite } = props;
        return (React.createElement(SiteContextProvider, { site: { isPremiumSite } },
            React.createElement(Component, { ...props })));
    };
}
export const useSiteContext = () => {
    const siteContext = React.useContext(SiteContext);
    if (!siteContext) {
        throw new Error('useSiteContext must be used within a SiteContextProvider');
    }
    return siteContext;
};
//# sourceMappingURL=site-context.js.map